import { useRef, useState } from "react";
import { EducacionFormal } from "../models/JuradosModel/jurados.model";
import DocumentosService from "../api/Documentos/api-documentos";
import { openNotification } from "../utils/Notifactions";

export const useEducacionFormal = () => {
  const [educacionFormalArray, setEducacionFormalArray] = useState< EducacionFormal[] >([]);
  const [educacionFormal, setEducacionFormal] =  useState<EducacionFormal>(initialValues);
  const [isGraduado, setIsGraduado] = useState(true);
  const formRef = useRef<any>();

  const guardarArchivo = async (e: any) => {
    if (e.target.files.length > 0) {
      if (e.target.files[0].size > 5000000) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos menores a 5MB",
          placement: "bottomRight",
        });
      }
      if (e.target.files[0].type === "application/pdf") {
        const formData = new FormData();
        formData.append("archivo", e.target.files[0]);
        const data = await DocumentosService.guardarArchivo(formData);
        return setEducacionFormal({ ...educacionFormal, path_anexo: data.data });
      } else {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos PDF",
          placement: "bottomRight",
        });
      }
    }
  };

  const handleGraduacion = ({ target }: any) => {
    const newGraduadoValue = target.value;
    setEducacionFormal({
      ...educacionFormal,
      graduado: newGraduadoValue,
      fecha_graduacion: "",
      path_anexo: "",
    });
    setIsGraduado(newGraduadoValue);
  };

  const resetForm = () => {
    formRef.current.resetFields();
    setEducacionFormal(initialValues);
  };

  const guardarFormulario = () => {
    //console.log(educacionFormal);
    setEducacionFormalArray((prevState) => [...prevState, educacionFormal]);
    resetForm();
  };

  return {
    educacionFormal,
    guardarFormulario,
    setEducacionFormal,
    guardarArchivo,
    formRef,
    resetForm,
    educacionFormalArray,
    setEducacionFormalArray,
    isGraduado,
    handleGraduacion,

  };
};

const initialValues = {
  nivel_educacion: null,
  titulo: "",
  institucion_educativa: "",
  ciudad: "",
  graduado: true,
  fecha_graduacion: "",
  path_anexo: "",
};
